import styled from '@emotion/styled'
import { ColumnBlock } from 'components/Column'
import { BREAKPOINTS } from 'utils/styled'

export const SWizardHeading = styled.div`
  display: flex;
  width: 100%;
  margin-bottom: 3rem;
  justify-content: space-between;
`

export const STextColumn = styled(ColumnBlock)`
  max-width: 46.5rem; //744px
  margin-right: 1rem;
`

export const SSideColumn = styled(ColumnBlock)`
  display: flex;
  align-items: center;
  justify-content: flex-end;

  @media ${BREAKPOINTS.LG.max} {
    display: none;
  }
`
